<script lang="ts">
import { computed, defineComponent, inject, onActivated, onMounted, ref, watch } from "vue";
import AnfrageService from "@/businesslogic/services/AnfrageService";
import Modal from "@/components/Modal.vue";
import TimeoutModal from "@/components/TimeoutModal.vue";
import Logger from "js-logger";
import formValidierung from "@/businesslogic/formValidierung";
import ValidierungsFehler from "@/components/ValidierungsFehler.vue";
import Adresse from "@/components/person/Adresse.vue";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "VHVElementarZusatz",
  components: {
    Adresse,
    Modal,
    TimeoutModal,
    ValidierungsFehler,
  },
  props: {},
  setup() {
    const piniaStore = useFormStore();
    const istSichtbar: any = inject("istSichtbar");
    const modalText = ref("");
    const buttonText = ref("");
    const zeigeModal = ref(false);
    const zeigeSpinner: any = inject("zeigeSpinner");
    const wechsleSichtbarkeit: any = inject("wechsleSichtbarkeit");
    const erfolgreichGeprueft = ref(false);
    const { validiereForm, getFormFehlerAnzahl, getFormFehler } = formValidierung();

    const fehler = ref({} as any);

    const fehlerMsg = computed(() => {
      let msg = "";
      const keys = Object.keys(fehler.value);
      for (const k in Object.keys(fehler.value)) {
        if (fehler.value[keys[k]] !== undefined) {
          msg += fehler.value[keys[k]] + "\n";
        }
      }
      return msg;
    });

    const zeigePruefungNichtErfolgt = ref(false);

    function pruefeZeigeModal() {
      let pruefungErfolgreich = true;
      if (!piniaStore.state.isMakler && piniaStore.state.zuersZone.zone === "4") {
        modalText.value =
          "Der Einschluss des Moduls Naturgewalten (Elementar) ist für diese Adresse online nicht möglich. Für ein individuelles Angebot erreichen Sie unser Beratungsteam von Montag bis Freitag (8 Uhr bis 18 Uhr) telefonisch unter 040 3766 3366 oder führen Sie die Berechnung ohne den Einschluss fort.";
        buttonText.value = "Weiter ohne Elementar";
        zeigeModal.value = !zeigeModal.value;
        pruefungErfolgreich = false;
      }
      if ((!piniaStore.state.zuersZone.zone || piniaStore.state.zuersZone.zone === "") && !piniaStore.state.isMakler) {
        modalText.value =
          "Für die eingegebene Anschrift konnte keine abschließende Prüfung erfolgen. Bitte beachten Sie, dass nach Antragstellung eine Prüfung durch unser Beratungsteam erfolgt und der Beitrag abweichen kann.";
        buttonText.value = "OK";
        zeigeModal.value = !zeigeModal.value;
        pruefungErfolgreich = true;
      }
      erfolgreichGeprueft.value = pruefungErfolgreich;
    }

    function toggleElementCheck() {
      if (!piniaStore.state.zuersZone.zone || piniaStore.state.zuersZone.zone === "") {
        zeigeModal.value = !zeigeModal.value;
      }
      if (piniaStore.state.zuersZone.zone === "4") {
        piniaStore.state.risikoAnschrift.strasse = "";
        piniaStore.state.risikoAnschrift.hausnummer = "";
        piniaStore.state.risikoAnschrift.ort = "";
        piniaStore.state.tarifinformationen.elementar = false;

        if (piniaStore.state.isMakler) {
          piniaStore.state.zuersZone.zone = "";
        } else {
          piniaStore.state.vhvElementarAusblenden = true;
        }
        zeigeModal.value = !zeigeModal.value;
      }
    }

    let timeoutcallback: any;
    const retry = () => {
      timeoutcallback();
    };

    const deaktivierteFelder = ref();

    const validiereElementar = async (pruefungMussErfolgtSein: boolean): Promise<boolean> => {
      zeigePruefungNichtErfolgt.value = false;

      await validiereForm("elementarForm", true);

      Logger.debug("Anzahl Fehler aus Elementar Validierung: ", getFormFehlerAnzahl());
      fehler.value = getFormFehler();

      const scrolleZuAnzeige = () => {
        document.querySelector("div#tariffOptionElementarAddressDiv")?.scrollIntoView({ behavior: "smooth" });
      };

      if (pruefungMussErfolgtSein && !erfolgreichGeprueft.value) {
        zeigePruefungNichtErfolgt.value = true;
        scrolleZuAnzeige();
      }

      return getFormFehlerAnzahl() == 0 && zeigePruefungNichtErfolgt.value === false;
    };

    const risikoAdresseRef = ref<InstanceType<typeof Adresse>>();

    async function ermittleZuersUndBerechneNeu() {
      const risikoAdresseValide = await risikoAdresseRef.value?.pruefen(
        true,
        (verlaesslich) => (piniaStore.state.risikoAnschrift.wurdeGeprueft = verlaesslich),
      );
      Logger.debug("risikoAdresseValide", risikoAdresseValide);
      if (risikoAdresseValide) {
        validiereElementar(false).then((isElementarValid) => {
          if (isElementarValid) {
            piniaStore.zuersUndGriLoeschen();

            AnfrageService.berechnen(
              piniaStore.getSessionToken(piniaStore.state),
              piniaStore.state,
              "VHVElementarZusatz",
              zeigeSpinner,
              (res: any) => {
                piniaStore.zuersUndGriAktualisieren(res.data);
                piniaStore.preiseAktualisieren(res.data);
                zeigePruefungNichtErfolgt.value = false;
                pruefeZeigeModal();
              },
              (fn: any) => {
                timeoutcallback = fn;
                wechsleSichtbarkeit("modal-timeout");
              },
            );
          }
        });
      }
    }

    onMounted(() => {
      deaktivierteFelder.value =
        piniaStore.state.risikoAnschrift.ort && piniaStore.state.risikoAnschrift.ort !== "" ? ["plz", "ort"] : ["plz"];
    });

    onActivated(() => {
      if (piniaStore.state.risikoAnschrift.ort === "") {
        deaktivierteFelder.value = ["plz"];
      } else {
        deaktivierteFelder.value = ["plz", "ort"];
      }
    });

    watch(
      () => [
        piniaStore.state.risikoAnschrift.plz,
        piniaStore.state.risikoAnschrift.ort,
        piniaStore.state.risikoAnschrift.strasse,
        piniaStore.state.risikoAnschrift.hausnummer,
      ],
      () => {
        erfolgreichGeprueft.value = false;
      },
    );

    return {
      ermittleZuersUndBerechneNeu,
      toggleElementCheck,
      piniaStore,
      zeigeModal,
      modalText,
      buttonText,
      retry,
      istSichtbar,
      erfolgreichGeprueft,
      fehler,
      validiereElementar,
      zeigePruefungNichtErfolgt,
      risikoAdresseRef,
      deaktivierteFelder,
      fehlerMsg,
    };
  },
});
</script>

<template>
  <form id="elementarForm" @submit.prevent="ermittleZuersUndBerechneNeu" novalidate>
    <div
      id="tariffOptionElementarAddressDiv"
      class="o-grid o-grid--align-middle o-grid--no-y-gutter gev19-elementar-addresscheck initiallyHidden"
    >
      <div class="o-grid__cell o-grid__cell--12">
        <span class="gev19-optional-module-subheading">Versicherungsort</span>
      </div>

      <adresse
        :fehler="fehler"
        :placeholder="true"
        :zeige-fehler="false"
        v-model:plz="piniaStore.state.risikoAnschrift.plz"
        v-model:ort="piniaStore.state.risikoAnschrift.ort"
        v-model:strasse="piniaStore.state.risikoAnschrift.strasse"
        v-model:hausnummer="piniaStore.state.risikoAnschrift.hausnummer"
        :feldNamen="{
          plz: 'risikoPlz',
          ort: 'risikoOrt',
          strasse: 'risikoStrasse',
          hausnummer: 'risikoHausnummer',
        }"
        :deaktivierte-felder="deaktivierteFelder"
        ref="risikoAdresseRef"
        :titel="{
          breite: 3,
          ausrichtungResponsiv: false,
        }"
        :ort-format="{
          breite: 6,
        }"
        :strasse-format="{
          breite: 7,
        }"
        :hausnummer-format="{
          breite: 2,
          style: 'width:100%',
        }"
        zeile-class="adressZeile"
      >
        <template v-slot:strasseHausnummerLabel>Straße und Nr.</template>
      </adresse>

      <validierungs-fehler :fehler-text="fehlerMsg" />

      <div class="o-grid__cell o-grid__cell--12">
        <div id="validierungsFehler">
          <validierungs-fehler :fehler-text="fehler.risikoOrt" />
          <validierungs-fehler :fehler-text="fehler.risikoStrasse" />
          <validierungs-fehler :fehler-text="fehler.risikoHausnummer" />

          <div v-if="zeigePruefungNichtErfolgt" class="gevng-form-validation__error-container">
            <span v-if="piniaStore.state.isMakler">
              <p>Online können wir Ihnen kein Vorschlag für den Einschluss der Elementargefahren erstellen.</p>
              <p>
                Bitte rufen Sie im Maklervertriebscenter unter der Telefonnummer 040 3766 3222 an. Sie erreichen uns von
                Montag bis Freitag von 8:00 bis 18:00 Uhr.
              </p>
            </span>
            <span v-else>
              Bitte prüfen und berechnen Sie die Naturgewalten, bevor Sie fortfahren oder deaktivieren Sie diese
              Erweiterung.
            </span>
          </div>
        </div>

        <div class="c-form-control u-text-align-right parsley-success" style="padding-top: 8px">
          <button :disabled="erfolgreichGeprueft" id="btnCheckAndCalculateElementar" class="c-button">
            {{ erfolgreichGeprueft ? "Prüfung erfolgreich!" : "Prüfen &amp; Berechnen" }}
          </button>
        </div>
      </div>

      <modal
        v-if="zeigeModal"
        @closeModal="toggleElementCheck"
        :hatSchliessenButton="true"
        :schliessenButtonText="buttonText"
        titel="Naturgewalten (Elementar)"
        :text="modalText"
      />
    </div>
  </form>

  <timeout-modal
    v-if="istSichtbar('modal-timeout')"
    :erste-seite="piniaStore.state.isMakler ? '/makler/vhv' : '/vhv'"
    @retry="retry"
  />
</template>

<style lang="scss">
.adressZeile {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>
